export default "__VITE_ASSET__a28a4919__"